import React from "react";
import greenCheckedFilled from "assets/images/icons/green-check-filled.svg";
import rightDirectionIcon from "assets/images/icons/right-direction-icon.svg";
import { CommonProgressBar } from "shared";
import { formatDuration } from "utils";

export const CourseCard = ({
  index,
  name,
  totalTasks,
  progress,
  isAssignment,
  isTheory,
  duration = "",
  onClick,
  displayDuration,
}) => {
  const isCompleted = progress === 100;
  return (
    <div
      className="grid-item mini-grid-item course-item-card"
      onClick={onClick}
    >
      <div className="grid-item-content row">
        <div className="grid-left-block col-12 col-md-9">
          <div
            className={`item-index ${isCompleted ? "course-item-completed" : ""
              }`}
          >
            {index + 1}
          </div>
          <div className="text-contents ps-4">
            <h2 className="ellipsis-text">{name}</h2>
            {!isTheory && (
              <div className="grid-sub-text">
                {totalTasks} Tasks{" "}
                {isAssignment &&
                  displayDuration &&
                  `• Duration: ${formatDuration(duration)}`}
              </div>
            )}
          </div>
        </div>
        <div className="grid-right-block col-12 col-md-3 justify-content-md-end">
          {!isTheory && (
            <>
              {isCompleted ? (
                <div className="complete-badge">
                  <img src={greenCheckedFilled} alt="" />
                  <span>Completed</span>
                </div>
              ) : (
                <CommonProgressBar width={progress} label={progress + "%"} />
              )}
            </>
          )}
          <div className="right-arrow-element d-none d-md-block">
            <img src={rightDirectionIcon} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};
